import find from 'lodash/find';

import {push} from '../router/router-actions';
import {OPTIMIZELY_VARIATION_EXPRESS_CHECKOUT} from 'plugins/optimizely/hooks/use-feature-variation';
import {
    getFeatureFromCookieWithFallback,
    IMMEDIATE_FEATURES,
} from 'utils/experiment';
import ErrorUtils from 'utils/error-utils';
import Config from '@/config/index';
import trackExpressEligibilityDetermined from 'segment/events/express-eligibility-determined';
export const SPOT_UPDATE_SELECTED = 'SPOT_UPDATE_SELECTED';
export const SPOT_CHANGE_MULTI_RATE = 'SPOT_CHANGE_MULTI_RATE';
export const SPOT_RESET_SELECTED_SPOT = 'SPOT_RESET_SELECTED_SPOT';
export const SPOT_RESET_SELECTED_RATE = 'SPOT_RESET_SELECTED_RATE';
export const SPOT_DETAIL_REFERRER = 'SPOT_DETAIL_REFERRER';

export const isExpressCheckoutEligible = ({
    spot,
    searchRequest,
    isRebookingReservation,
    eventPackage,
    isAdmin,
    optimizely,
}) => {
    let isEligible = false;

    if (Config.isDev && !Config.isDeployed) {
        trackExpressEligibilityDetermined({
            isAdmin,
            isEligible,
            isEventPackage: null,
            spotIsOn: null,
            isMonthly: null,
            isRebooking: null,
            badConfig: true,
        });

        return false;
    }

    if (!optimizely) {
        trackExpressEligibilityDetermined({
            isAdmin,
            isEligible,
            isEventPackage: null,
            spotIsOn: null,
            isMonthly: null,
            isRebooking: null,
            badOptimizelyLoad: true,
        });

        return false;
    }
    if (!spot.selectedRate) {
        trackExpressEligibilityDetermined({
            isAdmin,
            isEligible,
            isEventPackage: null,
            spotIsOn: null,
            isMonthly: null,
            isRebooking: null,
            selectedRatePresent: false,
        });

        return false;
    }
    try {
        const {
            monthly: isMonthly,
            rebook_reservation_id: rebookId,
        } = searchRequest;

        const isEventPackage = Boolean(eventPackage?.id);
        const isVerticalExpressAllowed = !isMonthly && !isEventPackage;
        const isRebooking = rebookId || isRebookingReservation;
        const freePark = spot.requireCreditCard === false;

        if (!freePark && isVerticalExpressAllowed && !isRebooking && !isAdmin) {
            isEligible = true;
        }

        trackExpressEligibilityDetermined({
            isAdmin,
            isEligible,
            isEventPackage,
            isMonthly,
            isRebooking,
        });

        if (isEligible) {
            isEligible =
                getFeatureFromCookieWithFallback(
                    optimizely,
                    IMMEDIATE_FEATURES.EXPRESS_CHECKOUT_WEB_DESKTOP_REFRESH,
                    {generateImpression: true}
                ) === OPTIMIZELY_VARIATION_EXPRESS_CHECKOUT;
        }
    } catch (e) {
        ErrorUtils.sendSentryMessage({
            error: e,
            customErrorMessage: 'Error in isExpressCheckoutEligible',
        });
    }

    return isEligible;
};

export const routeToCheckout = ({spot, optimizely}) => {
    return (dispatch, getState) => {
        const state = getState();

        const {
            searchRequest,
            checkout: {isRebookingReservation},
            user: {data: user},
            eventPackage: {data: eventPackage},
        } = state;

        const shouldSend = isExpressCheckoutEligible({
            spot,
            searchRequest,
            isRebookingReservation,
            eventPackage,
            isAdmin: user.isAdmin,
            optimizely,
        });

        if (shouldSend && spot.selectedRate.expressCheckoutUrl) {
            window.location.href = spot.selectedRate.expressCheckoutUrl;
        } else {
            dispatch(push(spot.selectedRate.fullUrl));
        }
    };
};

export const updateSelected = ({
    spot,
    referrer,
    goToSpotUrl = false,
    optimizely = null,
} = {}) => {
    return dispatch => {
        dispatch({
            type: SPOT_UPDATE_SELECTED,
            payload: {
                spot,
                referrer,
                goToSpotUrl,
            },
        });

        if (goToSpotUrl && spot) {
            dispatch(routeToCheckout({spot, optimizely}));
        }
    };
};

// Used on search controls only
export const resetSelectedSpot = () => {
    return {
        type: SPOT_RESET_SELECTED_SPOT,
    };
};

// Used on Checkout only
// newRateRule is number or string
export const changeMultiRate = ({newRateRule, rates}) => {
    const ruleNumber = parseInt(newRateRule, 10);
    const ruleRate = Number.isNaN(ruleNumber) ? newRateRule : ruleNumber;

    return {
        type: SPOT_CHANGE_MULTI_RATE,
        payload: {
            newRate: find(rates, {fullRule: ruleRate}) || null,
            rid: ruleRate,
        },
    };
};

// Used on Checkout only
export const resetSelectedRate = () => {
    return {
        type: SPOT_RESET_SELECTED_RATE,
    };
};

export const setSpotDetailReferrer = referrer => {
    return {
        type: SPOT_DETAIL_REFERRER,
        payload: {referrer},
    };
};
